const TEAM_NAMES: Record<string, string> = {
  "AL Masry": "المصري",
  "National Bank of Egypt": "البنك الأهلي المصري",
  "National Bank Egypt": "البنك الأهلي المصري",
  "Zamalek SC": "الزمالك",
  "Zamalek": "الزمالك",
  "El Zamalek": "الزمالك",
  "Al Jazira": "الجزيرة",
  "Al-Jazira": "الجزيرة",
  "Al Jazeera": "الجزيرة",
  "Al Khaleej": "الخليج",
  "Al Nassr": "النصر",
  "Como": "كومو",
  "Fiorentina": "فيورنتينا",
  "Frosinone": "فروزينوني",
  "Genoa": "جنوى",
  "Inter": "إنتر",
  "Juventus": "يوفنتوس",
  "Malaga": "مالاغا",
  "Monza": "مونزا",
  "Napoli": "نابولي",
  "Roma": "روما",
  "Udinese": "أودينيزي",
  "Abha": "أبها",
  "Ajman": "عجمان",
  "Al Ahli Doha": "الأهلي القطري",
  "Al Ain": "العين",
  "Al Khaleej Saihat": "الخليج",
  "Al Kholood": "الخلود",
  "Al-Kholood": "الخلود",
  "Al Okhdood": "الأخدود",
  "Al-Okhdood": "الأخدود",
  "Al Sadd": "السد",
  "Al Shabab": "الشباب",
  "Al Taawon": "التعاون",
  "Al-Ahli Jeddah": "الأهلي السعودي",
  "Al Ahli Saudi": "الأهلي السعودي",
  "Al-Ahli Saudi": "الأهلي السعودي",
  "Al Ahli Saudi FC": "الأهلي السعودي",
  "Al-Ahli Saudi FC": "الأهلي السعودي",
  "Al Hilal": "الهلال السعودي",
  "Al-Hilal": "الهلال السعودي",
  "Al Hilal Saudi": "الهلال السعودي",
  "Al-Hilal Saudi": "الهلال السعودي",
  "Al Hilal Saudi FC": "الهلال السعودي",
  "Al-Hilal Saudi FC": "الهلال السعودي",
  "Al-Dhafra": "الظفرة",
  "Al-Duhail SC": "الدحيل",
  "Al-Ettifaq": "الاتفاق",
  "Al-Fateh": "الفتح",
  "Al Fateh": "الفتح",
  "Al-Fayha": "الفيحاء",
  "Al Fayha": "الفيحاء",
  "Al-Ittihad": "الاتحاد",
  "Al Ittihad": "الاتحاد",
  "Al-Qadsiah": "القادسية",
  "Al Qadsiah": "القادسية",
  "Al-Riyadh": "الرياض",
  "Al Riyadh": "الرياض",
  "Al-Wehda": "الوحدة",
  "Al Wehda": "الوحدة",
  "Al-Sailiya": "السيلية",
  "Asyut Petrol": "أسيوط للبترول",
  "Athletic Club": "أتلتيك بلباو",
  "Auxerre": "أوكسير",
  "Brentford": "برينتفورد",
  "Celta Vigo": "سيلتا فيغو",
  "Crystal Palace": "كريستال بالاس",
  "El Geish": "طلائع الجيش",
  "Olympic El Qanah": "أولمبيك القناة",
  "Olympic Canal": "أولمبيك القناة",
  "Olympic Qanah": "أولمبيك القناة",
  "El Qanah": "القناة",
  "El Mokawloon": "المقاولون العرب",
  "Espanyol": "إسبانيول",
  "Estac Troyes": "تروا",
  "Everton": "إيفرتون",
  "Fenerbahçe": "فنربخشة",
  "Ghazl El Mehalla": "غزل المحلة",
  "Hatta SC": "حتا",
  "Hull City": "هال سيتي",
  "Ipswich": "إيبسويتش",
  "Kasımpaşa": "قاسم باشا",
  "Khorfakkan": "خورفكان",
  "Konyaspor": "قونيا سبور",
  "Le Mans": "لومان",
  "Lens": "لانس",
  "Lorient": "لوريان",
  "Lyon": "ليون",
  "Manchester City": "مانشستر سيتي",
  "Manchester City FC": "مانشستر سيتي",
  "Manchester United": "مانشستر يونايتد",
  "Nice": "نيس",
  "Nottingham Forest": "نوتنغهام فورست",
  "Osasuna": "أوساسونا",
  "CA Osasuna": "أوساسونا",
  "Paris FC": "باريس إف سي",
  "Petrojet": "بتروجت",
  "Pyramids FC": "بيراميدز",
  "Real Madrid": "ريال مدريد",
  "Real Sociedad": "ريال سوسيداد",
  "Real Sociedad de Fútbol": "ريال سوسيداد",
  "Rizespor": "ريز سبور",
  "Samsunspor": "سامسون سبور",
  "Sevilla": "إشبيلية",
  "Sevilla FC": "إشبيلية",
  "Seville": "إشبيلية",
  "Atlético Madrid": "أتلتيكو مدريد",
  "Atletico Madrid": "أتلتيكو مدريد",
  "Atletico de Madrid": "أتلتيكو مدريد",
  "Shabab Al Ahli Dubai": "شباب الأهلي دبي",
  "Smouha SC": "سموحة",
  "Stade Brestois 29": "ستاد بريست",
  "Sunderland": "سندرلاند",
  "Tottenham": "توتنهام",
  "Toulouse": "تولوز",
  "Valencia": "فالنسيا",
  "Villarreal": "فياريال",
  "Villarreal CF": "فياريال",
  "Alaves": "ألافيس",
  "Alavés": "ألافيس",
  "Deportivo Alaves": "ألافيس",
  "Deportivo Alavés": "ألافيس",
  "Çorum FK": "تشوروم",
  "Al Taawoun": "التعاون",
  "Al Taawoun FC": "التعاون",
  "Al Fayha FC": "الفيحاء",
  "Al Nassr FC": "النصر",
  "Al Riyadh SC": "الرياض",
  "Al Rayyan": "الريان",
  "Al Wakrah": "الوكرة",
  "Al Gharafa": "الغرافة",
  "Al Shamal": "الشمال",
  "Al Masry SC": "المصري",
  "Abu Qair Semad": "أبو قير للأسمدة",
  "Abu Qir Semad": "أبو قير للأسمدة",
  "Abu Qair Al Asmida": "أبو قير للأسمدة",
  "Al Ittihad Alexandria": "الاتحاد السكندري",
  "Al-Ittihad Alexandria": "الاتحاد السكندري",
  "El Gouna": "الجونة",
  "El Gouna FC": "الجونة",
  "Al Mokawloon Al Arab": "المقاولون العرب",
  "Al-Mokawloon Al-Arab": "المقاولون العرب",
  "Al Mokawloon Al-Arab FC": "المقاولون العرب",
  "Ceramica Cleopatra": "سيراميكا كليوباترا",
  "Ceramica Cleopatra FC": "سيراميكا كليوباترا",
  "Modern Sport FC": "مودرن سبورت",
  "Al Assiouty Sport": "بيراميدز",
  "Amed SK": "أمد سبور",
  "Amedspor": "أمد سبور",
  "Amed Sport": "أمد سبور",
  "Trabzonspor": "طرابزون سبور",
  "Trabzonspor FC": "طرابزون سبور",
  "Coca-Cola": "مودرن سبورت",
  "Modern Sport": "مودرن سبورت",
  "Chelsea": "تشيلسي",
  "Fulham": "فولهام",
  "Real Betis": "ريال بيتيس",
};

const LATIN_TO_ARABIC: Record<string, string> = { a: "ا", b: "ب", c: "ك", d: "د", e: "ي", f: "ف", g: "ج", h: "ه", i: "ي", j: "ج", k: "ك", l: "ل", m: "م", n: "ن", o: "و", p: "ب", q: "ق", r: "ر", s: "س", t: "ت", u: "و", v: "ف", w: "و", x: "كس", y: "ي", z: "ز" };
const LATIN_WORDS: Record<string, string> = { fc: "إف سي", sc: "إس سي", united: "يونايتد", city: "سيتي", county: "كاونتي", town: "تاون", real: "ريال", athletic: "أتلتيك", club: "نادي", olympique: "أولمبيك", sporting: "سبورتينغ", star: "ستار", stars: "ستارز" };

function transliterateUnknown(name: string) {
  return name.split(/\s+/).map((word) => LATIN_WORDS[word.toLowerCase()] ?? word.split("").map((letter) => LATIN_TO_ARABIC[letter.toLowerCase()] ?? letter).join("")).join(" ");
}

const ARABIC_TEAM_DISPLAY_ALIASES: Record<string, string> = {
  "ناشيونال بنك وف إيجيبت": "البنك الأهلي المصري",
  "ناشيونال بنك أوف إيجيبت": "البنك الأهلي المصري",
  "ناشيونال بنك ايجيبت": "البنك الأهلي المصري",
  "زمالك إس سي": "الزمالك",
  "زمالك اس سي": "الزمالك",
  "الزمالك إس سي": "الزمالك",
  "ريال مدريد سوسيداد": "ريال سوسيداد",
  "ريال سوكييداد": "ريال سوسيداد",
  "ناتيونال بانك وف يجيبت": "البنك الأهلي المصري",
  "زاماليك إس سي": "الزمالك",
  "زاماليك اس سي": "الزمالك",
  "ال ديريياه": "الرياض",
  "ال سوقوور": "الصقور",
  "ال-قاديسيياه": "القادسية",
  "ال-يتتيهاد إف سي": "الاتحاد",
  "ال-هازيم": "الحزم",
  "باركيلونا": "برشلونة",
  "يلكهي": "إلتشي",
  "اوساسونا": "أوساسونا",
  "وساسونا": "أوساسونا",
  "أأوساسونا": "أوساسونا",
  "باريس ساينت جيرماين": "باريس سان جيرمان",
  "ريننيس إف سي": "رين",
  "بيسيكتاس": "بشكتاش",
  "الانياسبور": "ألانيا سبور",
  "كوكايليسبور فك": "كوجالي سبور",
  "اميد سبور": "أمد سبور",
  "أميد سبور": "أمد سبور",
  "أميد سبورتي": "أمد سبور",
  "اميد سبورتي": "أمد سبور",
  "أمد سبورتي": "أمد سبور",
  "طرابزون": "طرابزون سبور",
  "ترابزون": "طرابزون سبور",
  "طرابزون سبورتي": "طرابزون سبور",
  "ترابزون سبورتي": "طرابزون سبور",
  "ديبورتيفو لا كوروñا": "ديبورتيفو لاكورونيا",
  "كيلتا دي فيجو": "سيلتا فيغو",
  "ال-ماسري إس سي": "المصري",
  "الرايان": "الريان",
  "الماسري إس سي": "المصري",
  "ابو قاير سيماد": "أبو قير للأسمدة",
  "أبو قاير سيماد": "أبو قير للأسمدة",
  "ابو قير للاسمدة": "أبو قير للأسمدة",
  "أبو قير للأسمده": "أبو قير للأسمدة",
  "الاتحاد السكندرى": "الاتحاد السكندري",
  "الاتحاد السكندري إف سي": "الاتحاد السكندري",
  "الجونه": "الجونة",
  "الجونة إف سي": "الجونة",
  "المقاولون العرب إف سي": "المقاولون العرب",
  "سيراميكا كليوباترا إف سي": "سيراميكا كليوباترا",
  "مودرن سبورت إف سي": "مودرن سبورت",
  "ال اسسيووتي سبورت": "بيراميدز",
  "مانشستر سيتي إف سي": "مانشستر سيتي",
  "مانشستر سيتي ف سي": "مانشستر سيتي",
  "اشبيليه": "إشبيلية",
  "إشبيليه": "إشبيلية",
  "اشبيلية": "إشبيلية",
  "إشبيلية إف سي": "إشبيلية",
  "اتليتكومدريد": "أتلتيكو مدريد",
  "اتلتيكومدريد": "أتلتيكو مدريد",
  "اتليتكو مدريد": "أتلتيكو مدريد",
  "أتليتكو مدريد": "أتلتيكو مدريد",
  "اتلتيكو مدريد": "أتلتيكو مدريد",
  "أتلتيكو مدريـد": "أتلتيكو مدريد",
  "أتلتيكو مدريد إف سي": "أتلتيكو مدريد",
  "فياريال سي إف": "فياريال",
  "فياريال إف سي": "فياريال",
  "الافيس": "ألافيس",
  "ألافيس ديبورتيفو": "ألافيس",
  "مانكهيستير سيتي": "مانشستر سيتي",
  "فيللارريال": "فياريال",
  "الافéس": "ألافيس",
  "ليللي": "ليل",
  "بيرامد سبورز": "بيراميدز",
  "بيرامد سبورت": "بيراميدز",
  "بيراميد سبورز": "بيراميدز",
  "الأهرام سبورت": "بيراميدز",
  "الأسيوطي سبورت": "بيراميدز",
  "ال-راييان": "الريان",
  "ال واكراه": "الوكرة",
  "ال سهامال إس سي": "الشمال",
  "ال-جهارافا": "الغرافة",
  "ال-هيلال ساودي": "الهلال السعودي",
  "ال-اهلي ساودي": "الأهلي السعودي",
  "وليمبيك يل قاناه": "أولمبيك القناة",
  "اوليمبيك يل قاناه": "أولمبيك القناة",
  "كوكا-كولا": "مودرن سبورت",
  "كهيلسيا": "تشيلسي",
  "ال ريياده": "الرياض",
  "ال-ناسسر": "النصر",
  "ال-فايها إف سي": "الفيحاء",
  "ال تااووون إف سي": "التعاون",
  "فولهام إف سي": "فولهام",
  "المصري إس سي": "المصري",
};

const TEAM_MATCH_ALIASES: Record<string, string> = {
  "يلكهي": "إلتشي",
  "باركيلونا": "برشلونة",
  "برشلونه": "برشلونة",
  "الاهلي": "الأهلي",
  "اهلي": "الأهلي",
  "انبي": "إنبي",
  "سيراميكا": "سيراميكا كليوباترا",
  "الراييان": "الريان",
  "الرايان": "الريان",
  "الواكراه": "الوكرة",
  "الجهارافا": "الغرافة",
  "السهامالاسسي": "الشمال",
  "الماسرياسسي": "المصري",
  "الاسسيووتيسبورت": "بيراميدز",
  "التاووونافسي": "التعاون",
  "الفايهافسي": "الفيحاء",
  "الناسسر": "النصر",
  "الديريياه": "الرياض",
  "كوكايليسبورفك": "كوجالي سبور",
  "مانشسترسيتي": "مانشستر سيتي",
  "اشبيليه": "إشبيلية",
  "اتليتكومدريد": "أتلتيكو مدريد",
  "اتلتيكومدريد": "أتلتيكو مدريد",
  "اتليتكو مدريد": "أتلتيكو مدريد",
  "اتلتيكو مدريد": "أتلتيكو مدريد",
  "فياريالافسي": "فياريال",
  "مانكهيستيرسيتي": "مانشستر سيتي",
  "فيللارريال": "فياريال",
  "الافيس": "ألافيس",
  "ليللي": "ليل",
};

function canonicalNameKey(value: string) {
  return value.normalize("NFKC").replace(/[ًٌٍَُِّْـ]/g, "").replace(/[أإآ]/g, "ا").replace(/ى/g, "ي").replace(/ة/g, "ه").replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/[^A-Za-z0-9\u0600-\u06ff]+/g, "").toLocaleLowerCase("ar-EG");
}

const CANONICAL_TEAM_NAMES = new Map<string, string>([
  ...Object.entries(TEAM_NAMES),
  ...Object.entries(ARABIC_TEAM_DISPLAY_ALIASES),
].map(([name, arabic]) => [canonicalNameKey(name), arabic]));

export function normalizeTeamNameForMatch(name?: string | null) {
  const value = (name ?? "").normalize("NFKC").replace(/[ًٌٍَُِّْـ]/g, "").replace(/[أإآ]/g, "ا").replace(/ى/g, "ي").replace(/ة/g, "ه").replace(/[.،,:;!?؟()\[\]{}'\"-]/g, "").replace(/\s+/g, " ").trim().toLocaleLowerCase("ar-EG");
  const alias = TEAM_MATCH_ALIASES[value] ?? TEAM_MATCH_ALIASES[canonicalNameKey(value)] ?? value;
  return alias.replace(/[ًٌٍَُِّْـ]/g, "").replace(/[أإآ]/g, "ا").replace(/ى/g, "ي").replace(/ة/g, "ه").replace(/\s+/g, "");
}

export function getArabicTeamName(name?: string | null) {
  if (!name) return "فريق غير معروف";
  const trimmed = normalizeArabicSportsText(name.replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\s+/g, " ").trim());
  if (TEAM_NAMES[trimmed]) return TEAM_NAMES[trimmed];
  if (ARABIC_TEAM_DISPLAY_ALIASES[trimmed]) return ARABIC_TEAM_DISPLAY_ALIASES[trimmed];
  if (trimmed === "اميد") return "أمد سبور";
  const canonical = CANONICAL_TEAM_NAMES.get(canonicalNameKey(trimmed));
  if (canonical) return canonical;
  if (/[\u0600-\u06ff]/.test(trimmed)) return trimmed;
  return transliterateUnknown(trimmed);
}

export function normalizeArabicSportsText(value?: string | null) {
  if (!value) return value ?? "";
  let result = value.replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\s+/g, " ").trim();
  const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  result = result
    .replace(/(?:أ+|ا)?وساسونا/g, "أوساسونا")
    .replace(/(?:أ?م|ا)يد\s+سبورت(?:ي)?/g, "أمد سبور")
    .replace(/(?:ت?ر)ابزون\s+سبورت(?:ي)?/g, "طرابزون سبور")
    .replace(/(?:ال)?مقاول(?:ون)?\s+العرب(?:\s+(?:إف|اف)\s*سي)?/g, "المقاولون العرب")
    .replace(/(?:أ|ا)بو\s+قير\s+لل(?:أ|ا)سمد(?:ة|ه)/g, "أبو قير للأسمدة")
    .replace(/الاتحاد\s+السكندر(?:ي|ى)(?:\s+(?:إف|اف)\s*سي)?/g, "الاتحاد السكندري")
    .replace(/الجون(?:ة|ه)(?:\s+(?:إف|اف)\s*سي)?/g, "الجونة")
    .replace(/سيراميكا\s+كليوباترا(?:\s+(?:إف|اف)\s*سي)?/g, "سيراميكا كليوباترا")
    .replace(/مودرن\s+سبورت(?:\s+(?:إف|اف)\s*سي)?/g, "مودرن سبورت")
    .replace(/بيرامد\s*سبورز?/g, "بيراميدز")
    .replace(/بيراميد\s*سبورز?/g, "بيراميدز")
    .replace(/الأهرام\s*سبورت/g, "بيراميدز")
    .replace(/Pyramids(?:\s+FC)?/gi, "بيراميدز")
    .replace(/Manchester\s+City(?:\s+FC)?/gi, "مانشستر سيتي")
    .replace(/(?:Atl[iíé]tico|Atletico)(?:\s+de)?\s+Madrid(?:\s+FC)?/gi, "أتلتيكو مدريد")
    .replace(/Sevilla(?:\s+FC)?/gi, "إشبيلية")
    .replace(/Villarreal(?:\s+CF|\s+FC)?/gi, "فياريال")
    .replace(/Deportivo\s+Alav[eé]s|Alav[eé]s/gi, "ألافيس");
  const aliases = [...Object.entries(TEAM_NAMES), ...Object.entries(ARABIC_TEAM_DISPLAY_ALIASES)].sort(([a], [b]) => b.length - a.length);
  for (const [from, to] of aliases) {
    if (/^[A-Za-z][A-Za-z .'-]*$/.test(from)) {
      result = result.replace(new RegExp(`(^|[^A-Za-z])${escapeRegex(from)}(?=$|[^A-Za-z])`, "gi"), `$1${to}`);
    } else {
      result = result.split(from).join(to);
    }
  }
  return result.replace(/(?:أ+|ا)?وساسونا/g, "أوساسونا").replace(/سبور(?:\s+سبور)+/g, "سبور");
}

export { ARABIC_TEAM_DISPLAY_ALIASES };

export { TEAM_NAMES };
